export class CommonRole {
  /**
   * The common role id
   */
  public id: number | null;

  /**
   *
   */
  public role_id: number | null;

  /**
   *
   */
  public name: string;

  /**
   *
   */
  public locale: string;

  /**
   *
   */
  public description: string | null;

  /**
   * Creates an instance of CommonRole.
   *
   * @param id the common role
   * @param role_id the role id
   * @param name the common role name
   * @param locale the locale
   * @param description the common role description
   */
  public constructor(
    id: number | null = null,
    role_id: number | null = null,
    name: string,
    locale: string,
    description: string | null = null
  ) {
    this.id = id;
    this.role_id = role_id;
    this.name = name;
    this.locale = locale;
    this.description = description;
  }
}
